// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

function FAQ({ faqs }) {
  return (
    <MKBox component="section" py={{ xs: 3, md: 12 }}>
      <Container>
        <Grid container alignItems="center">
          <Grid item xs={12} lg={2}>
            <MKTypography variant="h3" my={1}>
              FAQ
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={9} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
            <Stack>
              {faqs.map((item) => (
                <MKBox key={item.question} display="flex" alignItems="center" p={2}>
                  <MKBox
                    width="3rem"
                    height="3rem"
                    variant="gradient"
                    bgColor="info"
                    color="white"
                    coloredShadow="info"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="xl"
                  >
                    <Icon fontSize="small">{item.icon}</Icon>
                  </MKBox>
                  <Container>
                    <MKTypography variant="h6" color="text" pl={2}>
                      {item.question}
                    </MKTypography>
                    <MKTypography variant="body2" color="text" pl={2}>
                      {item.answer}
                    </MKTypography>
                  </Container>
                </MKBox>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

// Typechecking props for the seniorHealthData
FAQ.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};

export default FAQ;
